<template>
  <custom-dialog append-to-body width="80%" :title="model.title" :visible="visible" v-on="$listeners">
    <div style="padding: 0 24px">
      <el-tabs v-model="active">
        <el-tab-pane :label="$t('Common.com_department')" name="department"></el-tab-pane>
        <el-tab-pane :label="$t('Common.com_location')" name="location"></el-tab-pane>
      </el-tabs>
      <div v-show="active === 'department'">
        <!-- 集团大客户 -->
        <template v-if="isCoJv">
          <div class="table-bd">
            <custom-table
              stripe
              height="420px"
              type="checkbox"
              tableCode="portal_bind_department_loc"
              v-model="tableSelect"
              :data="tableList"
              @filter="filterChange"
              @sort="sortChange"
              :slots="['autoDeptList', 'action']"
            >
              <template slot="autoDeptList" slot-scope="scope">
                <el-tag size="small" style="margin-right: 6px" v-for="tag in scope.row.autoDeptList" :key="tag.bizId" closable @close="handleClose(scope.row, tag)">
                  {{ tag.bizName }}
                </el-tag>
              </template>
              <template slot="action" slot-scope="scope">
                <el-button type="text" size="mini" @click="onSelectDepartment(scope.row, scope.$index)">{{ $t('bind_department_location_dialog.xuan_ze_bu_men') }}</el-button>
              </template>
            </custom-table>
          </div>
          <div class="table-page">
            <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
          </div>
        </template>
        <!-- 租赁方 -->
        <template v-else>
          <search-input width="100%" :placeholder="$t('Common.com_department_name')" v-model="appKey"></search-input>
          <div style="padding: 24px 0; min-height: 537px">
            <custom-tree
              :expand-on-click-node="false"
              v-model="organData"
              :data="organTree"
              node-key="bizId"
              default-expand-all
              highlight-current
              :listener="appKey"
              :filterKeys="['bizName']"
              :props="{ label: 'bizName' }"
            >
              <template slot="label" slot-scope="scope">{{ scope.node.label }}</template>
            </custom-tree>
          </div>
        </template>
      </div>
      <div v-show="active === 'location'">
        <div class="ub">
          <div class="ub-f1" style="margin-right: 12px">
            <search-input width="100%" v-model="formSearch2.orgName" :placeholder="$t('bind_department_location_dialog.gong_si_ming_cheng')" @fetch="onPageChange2({ page: 1 })"></search-input>
          </div>
          <div class="ub-f2">
            <search-input width="100%" v-model="formSearch2.locationName" :placeholder="$t('Common.com_location_name')" @fetch="onPageChange2({ page: 1 })"></search-input>
          </div>
        </div>
        <div style="padding-top: 24px">
          <custom-table stripe height="420px" type="checkbox" tableCode="portal_select_location" v-model="tableSelect2" :data="tableList2" @filter="filterChange" @sort="sortChange"></custom-table>
        </div>
        <div class="table-page">
          <custom-pagination :total="totalRows2" :page="formSearch2.pageNum" :size="formSearch2.pageSize" @change="onPageChange2"></custom-pagination>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" :disabled="!organData && !tableSelect.length && !tableSelect2.length" @click="bindOrganLocation">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 选择部门 -->
    <select-department-dialog v-if="dialogVisible" :model="dialogModel" :organ="organ" @close="dialogVisible = false" @success="onSelectGroup"></select-department-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import customTree from '@/components/customTree.vue';
import selectDepartmentDialog from './select_department_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { customTree, selectDepartmentDialog },
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      active: '',
      appKey: '',
      organData: null,
      orgId: null,
      organTree: [],

      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,

      formSearch2: {
        userId: '',
        search: '',
        orderBy: '',
        orgName: '',
        locationName: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableSelect2: [],
      tableList2: [],
      totalRows2: 0,
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted() {
    this.getLocationList();
    this.active = 'department';
    if (this.isCoJv) {
      this.getOrganPage();
    } else {
      this.getOrganTree();
    }
  },
  methods: {
    // 获取子公司列表
    getOrganPage: function () {
      this.$getJSON(apis.OrganChildrenBizPage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.toBizType = 1;
          item.bizId = item.orgId;
          item.autoDeptList = [];
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 子公司分页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganPage();
    },
    // 选择部门
    onSelectDepartment: function (row, idx) {
      this.dialogModel.title = this.$t('bind_department_location_dialog.xuan_ze_bu_men');
      this.dialogModel.index = idx;
      this.dialogModel.orgId = row.orgId;
      this.dialogModel.defaultCheckedKeys = row.autoDeptList.map(f => f.bizId);
      this.dialogVisible = true;
    },
    // 保存部门
    onSelectGroup(rows) {
      const tableRow = this.tableList[this.dialogModel.index];
      if (tableRow) {
        tableRow.autoDeptList = rows || [];
      }
    },
    // 删除部门
    handleClose(row, tag) {
      row.autoDeptList = row.autoDeptList.filter(t => t.bizId !== tag.bizId);
    },
    // 获取部门树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { isCountDevice: 1 }).then((res) => {
        this.orgId = res.data.orgId;
        this.organTree = [res.data];
      });
    },
    // 获取项目列表
    getLocationList: function () {
      this.formSearch2.userId = this.model.userId;
      this.$getJSON(apis.deviceOrganLocation, this.formSearch2).then((res) => {
        this.tableList2 = res.data.list || [];
        this.totalRows2 = res.data.total;
      });
    },
    // 分页变更
    onPageChange2: function ({ page, size }) {
      this.formSearch2.pageNum = page;
      this.formSearch2.pageSize = size || this.formSearch2.pageSize;
      this.getLocationList();
    },
    // 关联项目、部门
    bindOrganLocation: function () {
      let params = [];
      if (this.isCoJv) {
        const paramOrgs = this.tableSelect.filter(t => t.autoDeptList.length === 0); // 组织
        const paramGroups = this.tableSelect.map(t => t.autoDeptList).reduce((pre, item) => [...pre, ...item], []); // 部门
        params = [...paramGroups, ...paramOrgs].map(t => ({
          bizId: this.model.userId,
          bizType: 3,
          toBizId: t.bizId,
          toBizType: t.toBizType,
          orgId: t.orgId,
        }));
      } else if (this.organData) {
        params.push({
          bizId: this.model.userId,
          bizType: 3,
          toBizId: this.organData.bizId,
          toBizType: this.organData.bizType,
          orgId: this.orgId,
        });
      }
      if (this.tableSelect2.length) {
        const arr = this.tableSelect2.map(t => ({
          bizId: this.model.userId,
          bizType: 3,
          toBizId: t.locationId, // 项目取locationId
          toBizType: 4, // 项目取值4
          orgId: t.orgId,
        }));
        params = [...params, ...arr];
      }
      this.$postJSON(apis.organDeviceBindAutoAdd, params, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
